<template>
  <div id="advertisingManage" class="pb-50">
    <div class="clearfix bg-f mb-5">
      <div class="title-tabs2 bg-f mb-5">
        <ul class="clearfix">

          <el-tabs v-model="activeName">
            <el-tab-pane v-for="(tab,index) in dataTabs" :key="index" :label="tab.name" :name="tab.type"></el-tab-pane>
          </el-tabs>
        </ul>
      </div>
    </div>
    <!-- 云商 -->
    <div v-if="activeName==0" class="bg-f black" style="padding:30px">
     <advertisement/>
    </div>
  </div>
</template>
<script>
import advertisement from "~/components/advertisement/advertisementList.vue";
export default {
  components:{
    advertisement
  },
  data() {
    return {
      dataTabs: [
        {type:'0',name:'云商商城'},
      ],
      activeName: '0',
    };
  },
  watch: {
    
  },
  methods: {
    
  },
  //进入加载
  mounted() {
    
  }
};
</script>

<style lang="less">
@import "../../../theme/util.less";
#advertisingManage {
    .el-button+.el-button {
        margin-left: 0px;
    }
  .ml-pic {
    margin-left: 185px;
    color: #ff4201;
    font-size: 12px;
  }
  .bb {
    border-bottom: 1px solid #dddddd;
  }
  .w400 {
    width: 420px !important;
  }
  .order_status {
    height: 60px;

    li {
      box-sizing: border-box;
      height: 26px;
      line-height: 26px;
      padding-left: 10px;
      padding-right: 10px;
      list-style-type: none;
      margin-top: 17px;
      margin-right: 10px;
      cursor: pointer;
      user-select: none;
      border-radius: 2px;

      &:hover {
        color: #ff4201;
      }
    }

    .active {
      border: 1px solid #ff4201;
      color: #ff4201;
    }
  }
  .startError {
    .el-form-item__error {
      margin-left: 70px;
    }
  }
  .EndError {
    .el-form-item__error {
      margin-left: -50px;
    }
  }
  .el-form-item__error {
    left: 24% ;
  }
  .formDiv{
    .avatar-uploader {
      margin-left: 190px;
      width: 90px ;
      height: 90px ;
      border: 1px solid #cccccc;
      overflow: hidden;
    }
    .el-upload-list__item {
      width: 90px ;
      height: 90px ;
    }
    .el-upload--text {
      width: 90px ;
      height: 90px ;
      border: 1px solid #ccc;
    }
    .fileList2 .el-upload--picture-card {
      display: none;
    }
    .el-upload--picture-card {
      width: 90px ;
      height: 90px ;
      line-height: 90px ;
      border: none ;
    }
  }

  .el-dialog {
    width: 860px;
    padding: 0 30px;
  }
  .el-dialog__body {
    padding-top: 20px;
  }
  .table-default .el-button {
    width: auto;
  }
  .el-table__body-wrapper {
    margin-top: 1px !important;
  }
  .bb {
    border-bottom: 1px solid #dddddd;
  }
  .c {
    position: relative;
  }
  .order_status {
    height: 60px;

    li {
      box-sizing: border-box;
      height: 26px;
      line-height: 26px;
      padding-left: 10px;
      padding-right: 10px;
      list-style-type: none;
      margin-top: 17px;
      margin-right: 10px;
      cursor: pointer;
      user-select: none;
      border-radius: 2px;

      &:hover {
        color: #ff4201;
      }
    }

    .active {
      border: 1px solid #ff4201;
      color: #ff4201;
    }
  }
  .count4 {
    position: absolute;
    left: 235px;
    top: 15px;
    z-index: 10;
  }

  .el-tabs__header {
    padding-left: 0;
  }

  .count2 {
    position: absolute;
    left: 308px;
    top: 15px;
    z-index: 10;
  }

  .count3 {
    position: absolute;
    left: 435px;
    top: 15px;
    z-index: 10;
  }

  .red {
    color: red;
  }

  .w-400 {
    width: 400px;
  }

  .w-160 {
    width: 160px;
  }

  .el-dialog {
    min-height: 300px;
  }

  .width-70 {
    width: 70px;
  }

  .black {
    .edit-btn span {
      color: #000000 !important;
    }
  }

  .obt {
    margin-top: 80px;
    margin-right: 60px;
  }
}
</style>